<template>
  <div class="info-widget">

    <div class="container-header">
      <div class="container-header__title">
        {{ i18n.dash_activity({ asset: currentAsset || '' }) }}
      </div>
      <div class="info-widget__actions btn-wrap">
        <md-button
          v-if="list.length > 0"
          :to="'/history/index/' + currentAsset"
          :disabled="accountState !== 'approved'"
          class="simple-link arrow"
        >
          {{ i18n.lbl_all_history() }}
        </md-button>
      </div>
    </div>

    <md-card class="container container_15_0 info-widget__content">
      <md-list
        v-if="list.length > 0"
        class="info-widget__list list_no-background md-layout"
      >
        <md-list-item
          class="info-widget__item"
          :md-ripple="false"
          :class="tx.state === 'rejected' || tx.state === 'failed' ? 'info-widget__item--opacity': ''"
          v-for="(tx, i) in list"
          :key="i"
          v-if="i < transactionsToShow"
          @click="makeDialogIsShow(list[i])"
        >
          <div class="info-widget__item-left">
            <div class="info-widget__name text_bold text_large">
              {{ tx.name }}
            </div>
            <div class="info-widget__counterparty text_medium">
              {{ tx.counterparty ? tx.counterparty : '-' }}
            </div>
            <div class="info-widget__date text_description text_small">
              {{ tx.date }}
            </div>
          </div>
          <div class="info-widget__item-right">
            <div
              class="info-widget__amount text_large"
              :class="[
                 'info-widget__amount--' + tx.direction,
                  tx.state === 'pending' ? 'info-widget__amount--pending' : '',
                  tx.state === 'rejected' || tx.state === 'failed' ? 'info-widget__amount--failed' : ''
              ]"
            >
              {{ tx.direction === 'in' ? '+' : '-' }}{{ i18n.c(swimAmount(tx.asset, tx.amount)) }} {{ formatAsset(tx.asset) }}
            </div>
            <div class="info-widget__converted text_medium">
             <span>{{ i18n.lbl_fees_label() }}</span> {{ i18n.c(swimAmount(tx.asset, getTotalFees(tx))) }} {{ formatAsset(tx.asset) }}
            </div>
            <div class="info-widget__state text_small">
              <span class="cell-state__inner" :class="tx.state">{{ i18n.tx_state(tx.state) }}</span>
            </div>
          </div>
        </md-list-item>
      </md-list>

      <div
        v-else
        class="container__no-data container_40 text-center"
      >
        <md-icon class="md-size-4x">trending_up</md-icon>
        <div class="text_xl_large">{{ i18n.th_no_transaction_history() }}</div>
        <div class="text_margin text_medium">
          <span>{{ i18n.th_no_transaction_history_search() }}</span>
          <span @click="openDialog()" class="contact-us__link">{{ i18n.lbl_contact_us() }}</span>
          <span>{{ i18n.th_no_transaction_history_search_end() }}</span>
        </div>
        <contact-us
          class="contact-us__popup"
          v-on:close-dialog="closeDialog"
          v-if="showDialog"
          :showDialog="showDialog"
        />
      </div>
      <md-button
        class="md-button btn md-primary md-theme-default md-yellow flex-btn"
        @click="refresh"
      >
        {{ i18n.lbl_update() }}
        <md-icon class="md-size-1x">autorenew</md-icon>
      </md-button>
    </md-card>

    <info-dialog
      v-on:close-dialog="closeDialog"
      v-if="showDialog"
      :dialogValues="dialogValues"
      :showDialog="showDialog"
    />
  </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import { vuexTypes } from '@vuex/types'
  import { formatDate } from '@utils/dates.util'
  import { RecordTypes } from '@js/records/types'
  import { PricesHelper } from '@vuex/helpers/prices.helper'
  import { DEFAULT_CONVERSION_ASSET } from '@const'
  import { i18n } from '@js/i18n'
  import { CurrencyHelper } from '@js/helpers/currency.helper'

  import get from 'lodash/get'

  import InfoDialog from './Dashboard.InfoDialog'
  import CurrencyRound from '@com/mixins/currency.round.mixin'
  import ContactUs from '../../../navigation/contact-us_popup/contact-us'
  import {isCryptoAsset, formatTokenDisplay} from '@utils/consts'

  export default {
    name: 'info-widget',
    mixins: [CurrencyRound],
    components: { InfoDialog, ContactUs },
    data: _ => ({
      transactionsToShow: 3,
      showDialog: false,
      dialogValues: {},
      i18n,
      formatDate,
      DEFAULT_CONVERSION_ASSET,
      CurrencyHelper
    }),
    props: ['currentAsset', 'accountState'],
    created () {
      this.loadList({risk_type: 'all', code: this.currentAsset})
    },
    computed: {
      ...mapGetters([
        vuexTypes.transactions,
        vuexTypes.userWalletTokens
      ]),
      list () {
        let trs = get(this.transactions, `${this.currentAsset}.records`) || []
        this.loadUsersDetails(trs)
        return trs
          .reduce((list, item) => {
            if (item instanceof RecordTypes.MatchRecord) {
              item.transactions.forEach(tx => { list.push(tx) })
              return list
            }
            list.push(item)
            return list
          }, [])
      }
    },
    methods: {
      ...mapActions({
        loadList: vuexTypes.GET_TX_LIST,
        loadUsersDetails: vuexTypes.UPDATE_TX_COUNTERPARTIES
      }),
      refresh () {
        this.loadList({risk_type: 'all', code: this.currentAsset})
      },
      formatAsset (token) {
        if (isCryptoAsset(token)) {
          return formatTokenDisplay(token)
        }
        return CurrencyHelper.getCurrencyIcon(token)
      },
      swimAmount (token, amount) {
        if (isCryptoAsset(token)) {
          return this.roundCurrency2(amount, token)
        }
        return this.roundCurrency(amount, token)
      },
      convertAmount (amount) {
        return PricesHelper.baseToQuote(amount, this.currentAsset, DEFAULT_CONVERSION_ASSET)
      },
      makeDialogIsShow (list) {
        this.showDialog = true
        this.dialogValues = list
      },
      closeDialog (status) {
        this.showDialog = status
      },
      getTotalFees (tx) {
        if (tx.percentFee && tx.fixedFee) {
          return parseFloat(tx.percentFee) + parseFloat(tx.fixedFee)
        } else if (tx.fees) {
          return parseFloat(tx.fees.source) + parseFloat(tx.fees.destination)
        }
        return 0
      },
      openDialog () {
        this.showDialog = true
      }
    },
    watch: {
      currentAsset (value) {
        this.loadList({risk_type: 'all', code: value})
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import '~scss/variables.scss';
  @import '~scss/mixins.scss';

  .flex-btn {
    max-width: 100px;
    margin-left: auto;
    margin-right: 15px;
    .md-icon {
      color: $default-light-white;
    }
    .md-icon-font {
      color: $default-black !important;
    }
  }

  .info-widget {
    display: flex;
    flex-direction: column;
    flex: 3 3 auto;

    @include respond-to(medium) {
      max-width: inherit;
    }

    @include respond-to(xsmall) {
      max-width: 100%;
    }

    &__content {
      display: flex;
      flex: 1 1 auto;
      flex-direction: column;
      justify-content: space-between;
    }

    &__item {
      display: flex;
      justify-content: space-between;

      & /deep/ .md-list-item-content {
        padding: 0;
      }

      &:not(:last-child) {
        border-bottom: 1px solid $col-border;
      }
    }

    &__name {
      letter-spacing: .2px;
    }

    &__counterparty,
    &__converted {
      margin: 12px 0;
      white-space: nowrap;
    }

    &__counterparty {
      max-width: 400px;
      min-height: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      @include respond-to(medium) {
        max-width: 300px;
      }
    }

    &__item--opacity {
      opacity: .7;
    }

    &__amount {
      font-weight: 700;
    }

    &__amount--in { color: $col-success; }
    &__amount--out { color: $col-error; }
    &__amount--pending { color: orange; }
    &__amount--failed { color: $col-disabled; }

    &__state {
      & .cell-state__inner {
        position: relative;

        &:after {
          content: url("/static/img/success_icon.svg");
          position: absolute;
          top: 50%;
          left: -20px;
          max-height: 22px;
          transform: translateY(-50%);
        }

        &.success {
          color: $col-success;
        }
        &.pending {
          color: orange;
          &:after {
            content: url("/static/img/pending_icon.svg");
          }
        }
        &.fully, &.matched, &.fully_matched {
          color: $col-disabled;
          &:after {
            content: '';
          }
        }
        &.rejected,
        &.failed {
          color: $col-invalid;
          &:after {
            content: '';
          }
        }
      }
    }

    &__item-left {
      flex: 1 1 auto;
      @include respond-to(xsmall) {
        flex: none;
        width: 130px;
      }
    }

    &__item-right {
      flex: 0 0 auto;
      text-align: right;

      @include respond-to(xsmall) {
        flex: none;
        width: calc(100% - 130px);
      }
    }
  }

  .contact-us__link {
    color: $col-text-secondary;
    text-transform: lowercase;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// src/vue/app/dashboard/index/Dashboard.InfoWidget.vue